
import { View } from 'backbone';
import Immutable from 'immutable';
import contentTemplate from 'properties/style/text.ejs';
import BasePropertyView from 'BasePropertyView.js'
import util from 'util/Util.js';
import themeService from 'ThemeService.js';
import textUtil from 'util/TextUtil';
import fontService from 'FontService';

class StyleTextView extends BasePropertyView {

    initialize(opts) {
        // Commented Out because this view should not listen to ALL model changes.
        //super.initialize(this.options);
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;


        this.listenTo(this.model, 'change:fontFamily change:fontSize change:textWeight', this.updateTextSize);
        this.listenTo(this.model, 'change:text ', this.updateText);

        let currentFont = themeService.resolveThemeFont('fontFamily', this.model.get('fontFamily'));
        fontService.initCustomFont(this.model, currentFont);

        return this;
    }

    updateTextSize() {
        textUtil.updateTextContent(this.model, true);
    }

    updateText() {
        // Change \n with \r
        let text = this.model.get('text');
        if (text) {
            text = text.replace(/\r?\n/g, "\r");
        }
        this.model.set('text', text, { silent: true });

        textUtil.updateTextContent(this.model, false);
    }

    render() {
        const alignRightBI = Immutable.Set([
            'control_text_input',
            'control_multiple_text_input',
            'control_numeric_input',
            'control_date_input',
            'control_date_calendar',
            'control_time_input',
            'control_checkbox_group',
            'control_mask_text_input',
            'control_image_input',
            'control_radio_button',
            'control_radio_button_group',
            'control_image_input',
            'control_numeric_stepper',
            'control_password_input',
            'control_vertical_slider',
            'control_horizontal_slider',
            'control_ranking',
            'control_clear_filter_button',
            'control_print_button',
            'control_submit_button'
        ]);
        this.model.set('alignRightBI',alignRightBI,{silent: true});
        this.model.set('sectionLabel', 'Text', {silent : true});
        if (this.model.get('factoryKey')==='control_image_input') {
            this.model.set('sectionLabel', 'Status', {silent : true});
        }

        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));

        return this;
    }  
}

export default StyleTextView;
